import styled from 'styled-components';
import { IconActionLink } from '@cko/icons';
/**
 * @deprecated - Please use the IconActionLink component from UI Toolkit directly
 * {@link https://frontend-ds.cko-dev.ckotech.co/?path=/docs/icons-icons--docs}
 **/
export const StyledActionLink = styled(IconActionLink) `
  ${({ margin }) => margin && `margin: ${margin};`}

  cursor: pointer;

  path {
    fill: var(--action-icon-primary);
`;
